export default function SFolder({ size = 20, className = "", ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="1.5 3 17 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M3.33317 16.6668C2.87484 16.6668 2.48262 16.5038 2.1565 16.1777C1.83039 15.8516 1.66706 15.4591 1.6665 15.0002V5.00016C1.6665 4.54183 1.82984 4.14961 2.1565 3.8235C2.48317 3.49738 2.87539 3.33405 3.33317 3.3335H8.33317L9.99984 5.00016H16.6665C17.1248 5.00016 17.5173 5.1635 17.844 5.49016C18.1707 5.81683 18.3337 6.20905 18.3332 6.66683V15.0002C18.3332 15.4585 18.1701 15.851 17.844 16.1777C17.5179 16.5043 17.1254 16.6674 16.6665 16.6668H3.33317Z"
                fill="currentColor"
            />
        </svg>
    )
}